import { API, ApiInit } from '@/api';
//import axios from 'axios';
import router from '@/router';

const state = {
  cliente: '',
  user: {},
  token: '',
};
const getters = {
  getClient: (State) => {
    console.debug('state', state);
    // cliente debe ser de tipo number
    // cliente = 0 corresponde a logged out
    if (typeof state.cliente === 'number' && state.cliente !== 0) {
      return state.cliente;
    } else if (typeof window.sessionStorage.getItem('cliente') === 'string') {
      return Number(window.sessionStorage.getItem('cliente'));
    } else {
      console.error('Error parsing window.sessionStorage.getItem("cliente")');
      return 0
    }
  },
  getUser: (State) => {
    console.debug('state', state);
    // user debe ser de tipo object
    // user = {} corresponde a logged out
    if (typeof state.user === 'object' && Object.keys(state.user).length > 0) {
      return state.user;
    } else if (typeof window.sessionStorage.getItem('user') === 'string') {
    // para interpretar como objeto, es necesario usar JSON.parse
      return JSON.parse(window.sessionStorage.getItem('user') || '{}');
    } else {
      console.error('Error parsing window.sessionStorage.getItem("user")');
      return {};
    }
  },
  getToken: (State) => {
    console.debug('state', state);
    // token debe ser de tipo string
    // token = '' corresponde a logged out
    if (typeof state.token === 'string' && state.token.length > 0) {
      return state.token;
    } else if (typeof window.sessionStorage.getItem('token') === 'string') {
      return window.sessionStorage.getItem('token');
    } else {
      console.error('Error parsing window.sessionStorage.getItem("token")');
      return '';
    }
  },
};
const actions = {
  login({commit, State}, {username, password}) {
//    const response = 
//    let API = (await ApiInit())[0];
	return ApiInit()
	.then(result => 
    	API.post('/login', {username, password})
    	)
    .then(data => {
      if (data.status === 200) {
        commit('setToken',data.headers.authorization);

        let user = API.get('/current/user', {headers: { Authorization: data.headers.authorization, }})
        .then(data => {
          commit('setUser', data.data);
          return data;
        });
    	
    	let cliente = API.get('/current/cliente', {headers: { Authorization: data.headers.authorization, }})
           .then(data => {
             commit('setClient', data.data.id);
             return data;
              //commit('setUserPermissions', data.data.roles);
              /*router.push({
                name: 'Menu'
              });*/
//                return Promise.resolve(data);
           });
    	return Promise.all([user, cliente]);
      }
    }).then(res => {
      router.push({name: 'Menu'});
      return res;
    })
    ;
    
//    return response;
  },

  logout({dispatch}) {
    if (router.history.current.name === 'Confirmar') return;
    if (router.history.current.name === 'CambiarPassword') return;
    dispatch('setClient', 0);
    dispatch('setToken', '');
    dispatch('setUser', {});
    dispatch('setDocument', '');
    router.push({name: 'Login'});
  },

  async registrarCliente({commit, State}, {request}) {
    const response = await API.put('/useradmin/registra', request);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async confirmarUsuario({commit, State}, {userId, token}) {
    const req = {
      id: userId,
      token,
    };
    const response = await API.post(`/useradmin/activar`, req);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async addCliente({commit, State},{nombre}) {
    const response = await API.post('/clientes/add', {nombre});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async getCliente({commit, State},{id}) {
    const response = await API.get(`/clientes/get/${id}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async listClientes({commit, State}) {
    const response = await API.get('/clientes/list');
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async changePassword({commit, State},{request}) {
    const response = await API.post('/useradmin/changePassword', request);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async requestPasswordRecovery({commit, State}, {request}) {
    const response = await API.post('/passwordRecover/changePassword/sendRequest', request);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async recoverPassword({commit, State}, {request}) {
    const response = await API.post('/passwordRecover/changePassword', request);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  setClient({ commit, State }, cliente, str) {
    commit('setClient', cliente);
  },
  setToken({ commit, State }, token) {
    commit('setToken', token);
  },
  setUser({ commit, State }, user) {
    commit('setUser', user);
  },
};
const mutations = {
  setClient: (State, cliente) => {
      // cliente debe ser Number
      State.cliente = Number(cliente);
      window.sessionStorage.setItem('cliente', cliente);
  },
  setToken: (State, token) => {
      // token debe ser String
      State.token = token;
      window.sessionStorage.setItem('token', token);
  },
  setUser: (State, user) => {
      // user debe ser Object
      // para almacenar es necesario usar JSON.stringify
      State.user = user;
      window.sessionStorage.setItem('user', JSON.stringify(user));
  },
};

export default {
  actions,
  mutations,
  getters,
  state,
};
